import { useQuery } from '@tanstack/react-query';
import { GetPrLeaderBySlugQuery } from '@/graphql/gql/graphql';
import { getLeaderBySlug } from '../api';

const useLeaderBySlug = (slug: string) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['leader', slug],
    queryFn: () => getLeaderBySlug(slug),
    select: (response: GetPrLeaderBySlugQuery) => {
      return response.allPrLeader ?? [];
    },
  });

  return { data, isError, isLoading };
};

export default useLeaderBySlug;
